import { render, staticRenderFns } from "./TargetedSMSSingle.vue?vue&type=template&id=17ddb10c&scoped=true&"
import script from "./TargetedSMSSingle.vue?vue&type=script&lang=js&"
export * from "./TargetedSMSSingle.vue?vue&type=script&lang=js&"
import style0 from "./TargetedSMSSingle.vue?vue&type=style&index=0&id=17ddb10c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ddb10c",
  null
  
)

export default component.exports